var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-animation"},[_c('div',{staticClass:"block"}),_vm._v(" "),_c('div',{staticClass:"preview"}),_vm._v(" "),_c('modal-window',{attrs:{"visible":_vm.isShow},on:{"close":_vm.close}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }